<script lang="ts" setup>
defineProps<{ name: string; to: string }>();
</script>

<template>
  <li>
    <v-btn
      :block="$vuetify.display.mdAndDown"
      :class="$route.name === to ? 'bg-grey-lighten-2' : ''"
      class="font-weight-medium mr-1"
      variant="plain"
      :href="to.includes('http') ? to : undefined"
      :to="to.includes('http') ? undefined : { name: to }"
      :target="to.includes('http') ? '_blank' : undefined"
    >
      {{ name }}
    </v-btn>
  </li>
</template>
